import { h, JSX } from 'preact'
import Icon from '../assets'

interface Props {
  phrase: string | JSX.Element
}

const PinnedReplyLabel = ({ phrase }: Props): JSX.Element =>
  <div class='pinned-reply__label'><Icon icon='pin' height={20} width={20} />{phrase}</div>

export default PinnedReplyLabel
